import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Redirect } from 'react-router'
import styled from 'styled-components'
import { TabContent, TabPane } from 'reactstrap'
import { get, set, find, orderBy } from 'lodash'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  projectInformationAction,
  lobAction,
  companyAction,
  departmentAction,
  employeeAction,
  clientMasterAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  projectInformationSelector,
  lobSelector,
  companySelector,
  departmentSelector,
  employeeSelector,
  clientMasterSelector,
  sidebarSelector,
  headerSelector,
} from './../../selectors'
import {
  createClientList,
  createResourceList,
  createProjectManagerList,
} from '../../function'
import CustomModal from '../../components/modal'
import { SimpleModal } from '../../components/modal/simple-modal'
import CustomModalMessage from '../../components/modal-message'
import withLayout from '../../helpers/withLayout'
import Header from '../../components/project-information/header'
import Tab from '../../components/project-information/tab'
import { buttonOK, buttonTryAgain, buttonDiscard } from '../../components/project-information/helper/button'
import {
  OverviewTab,
  ChangeRequestTab,
  AttachmentTab,
  CostPlanningTab,
  RevenuePlanningTab,
  BillingTab,
} from '../../components/project-information/tab-content'
import Manual from '../../components/project-information/helper/manual'

// let prevOffsetTop = 0

class ProjectInformationPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const access_token = localStorage.getItem('access_token')
    const tempState = prevState
    if (get(nextProps, 'getProjectInformationByIDData.project')
    && get(nextProps, 'getCompanyData')
    && get(nextProps, 'getDepartmentData')
    && get(nextProps, 'getLOBData')
    && get(nextProps, 'getClientData')) {
      const projectByID = get(nextProps, 'getProjectInformationByIDData.project')[0]
      const users = get(nextProps, 'getProjectInformationByIDData.users')
      projectByID.resources = projectByID.resources.map(res => {
        const tempRes = res
        delete tempRes.level
        return tempRes
      })
      set(tempState, 'project', projectByID)
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'users', users)
      set(tempState, 'lobs', get(nextProps, 'getLOBData'))
      const companys = orderBy(get(nextProps, 'getCompanyData'), ['name', ['asc']])
      const lobs = orderBy(get(nextProps, 'getLOBData'), ['name'], ['asc'])
      const departments = orderBy(get(nextProps, 'getDepartmentData'), ['name'], ['asc'])
      const managersList = createProjectManagerList(users)
      const managers = []
      projectByID.project_manager_ids.map(m => {
        const mgr = find(managersList, { _id: m })
        if (mgr !== undefined) managers.push(mgr)
        return m
      })
      set(tempState, 'project_managers', managers)
      set(tempState, 'employees', createResourceList(get(nextProps, 'getProjectInformationByIDData.users'), lobs, departments))
      set(tempState, 'companys', companys)
      set(tempState, 'lobs', lobs)
      set(tempState, 'departments', departments)
      set(tempState, 'changeableProjectStatus', get(nextProps, 'getProjectInformationByIDData.changeableProjectStatus'))
      set(tempState, 'change_project_status', get(nextProps, 'getProjectInformationByIDData.changeableProjectStatus')[0])
      // set(tempState, 'projectSubmit', get(nextProps, 'getProjectInformationByIDData.projectSubmit')[0])
      set(tempState, 'last_submit_request', get(nextProps, 'getProjectInformationByIDData.lastProjectSubmitRequest'))
      if (projectByID.presale_snapshot) {
        set(tempState, 'rSelected', 2)
      }
      const clientList = createClientList(get(nextProps, 'getClientData'))
      set(tempState, 'clients', clientList)
      set(tempState, 'project_snapshots', projectByID.project_snapshots)
      nextProps.resetGetProjectInformationByID()
    }
    if (get(nextProps, 'editProjectInformationData.updatedProject')) {
      const status = get(nextProps, 'editProjectInformationData.status')
      const message = get(nextProps, 'editProjectInformationData.message')
      if (get(nextProps, 'editProjectInformationData.status') === 200
      && get(nextProps, 'editProjectInformationData.commit')) {
        nextProps.getProjectInformationByID(prevState.projectID, access_token)
        nextProps.showConfirm('editSuccess', status, message)
      } else if (get(nextProps, 'editProjectInformationData.status') !== 200) {
        nextProps.getProjectInformationByID(prevState.projectID, access_token)
        nextProps.showConfirm('editSuccess', status, message)
      } else {
        set(tempState, 'projectByID', get(nextProps, 'editProjectInformationData.updatedProject')[0])
        set(tempState, '$resource_cost', get(get(nextProps, 'editProjectInformationData.updatedProject')[0], '$resource_cost'))
      }
      nextProps.resetEditProjectInformation()
    }
    if (get(nextProps, 'autoFillManDaysData.project')) {
      const status = get(nextProps, 'autoFillManDaysData.status')
      const message = get(nextProps, 'autoFillManDaysData.message')
      set(tempState, 'projectByID', get(nextProps, 'autoFillManDaysData.project'))
      nextProps.showConfirm('editSuccess', status, message)
      nextProps.resetAutoFillManDays()
    }
    if (get(nextProps, 'changeStatusProjectInformationData.updatedProject')) {
      const status = get(nextProps, 'changeStatusProjectInformationData.status')
      const message = get(nextProps, 'changeStatusProjectInformationData.message')
      nextProps.showConfirm('editSuccess', status, message)
      set(tempState, 'project', get(nextProps, 'changeStatusProjectInformationData.updatedProject')[0])
      set(tempState, 'project_status', get(nextProps, 'changeStatusProjectInformationData.updatedProject')[0].project_status)
      nextProps.getProjectInformationByID(prevState.projectID, access_token)
      nextProps.resetChangeStatusProjectInformation()
    }
    if (get(nextProps, 'submitProjectInformationData.project')) {
      const status = get(nextProps, 'submitProjectInformationData.status')
      const message = get(nextProps, 'submitProjectInformationData.message')
      nextProps.showConfirm('editSuccess', status, message)
      nextProps.resetSubmitProjectInformation()
      nextProps.getProjectInformationByID(prevState.projectID, access_token)
    }
    if (get(nextProps, 'approveProjectInformationData.project')) {
      const status = get(nextProps, 'approveProjectInformationData.status')
      const message = get(nextProps, 'approveProjectInformationData.message')
      nextProps.showConfirm('approveSuccess', status, message)
      nextProps.resetApproveProjectInformation()
      nextProps.getProjectInformationByID(prevState.projectID, access_token)
    }
    if (get(nextProps, 'saveSnapshotData.updatedProject')) {
      const status = get(nextProps, 'saveSnapshotData.status')
      const message = get(nextProps, 'saveSnapshotData.message')
      nextProps.showConfirm('saveSnapshot', status, message)
      if (status === 200) {
        nextProps.getProjectInformationByID(prevState.projectID, access_token)
      }
      nextProps.resetSaveSnapshot()
    }
    if (get(nextProps, 'getSnapshotData.projectSnapshot')) {
      const projectSnapshot = get(nextProps, 'getSnapshotData.projectSnapshot.project_snapshot')
      set(tempState, 'projectByID', projectSnapshot)
      if (projectSnapshot.presale_snapshot) {
        set(tempState, 'rSelected', 2)
      }
      nextProps.resetGetSnapshot()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.changeRequest = React.createRef()
    this.costPlanning = React.createRef()
    this.billing = React.createRef()
    this.state = {
      redirect: false,
      selectedVersion: '',
      rSelected: 1,
      activeTab: '1',
      projectID: get(props, 'match.params.id'),
      projectInformation: [],
      project: null,
      lobs: [],
      companys: [],
      departments: [],
      approvers: [],
      managers: [],
      pm_supervisors: [],
      employees: [],
      clients: [],
      changeableProjectStatus: [],
      project_managers: [],

      editVendor: false,
      editProjectInfo: false,
      editBreakDown: false,
      editLicense: false,
      editHardware: false,
      editChangeRequest: false,
      editAttachment: false,
      editResource: false,
      editOtherCost: false,
    }
  }

  componentDidMount() {
    const maintenanceMsg = process.env.REACT_APP_MAINTENANCE_MESSAGE
    if (maintenanceMsg && maintenanceMsg !== '') this.props.showModal('alert', '', maintenanceMsg)
    const access_token = localStorage.getItem('access_token')
    const { location: { state } } = this.props
    this.props.getAuth(access_token)
    this.props.getProjectInformationByID(get(this.props, 'match.params.id'), access_token)
    this.props.getEmployee(access_token)
    this.props.getLOB(access_token)
    this.props.getCompany(access_token)
    this.props.getDepartment(access_token)
    this.props.getClient(access_token)
    if (state && state.activeTab) {
      this.setState({ activeTab: state.activeTab })
    }
    // const root = document.getElementById('root')
    // root.addEventListener('scroll', this.handleScroll)
    // prevOffsetTop = root.offsetTop
  }

  onRadioBtnClick = (rSelected) => {
    this.setState({ rSelected })
  }

  toggle = (tab) => {
    const { isEditRevenuePlanning } = this.props
    const {
      editVendor,
      editProjectInfo,
      editBreakDown,
      editLicense,
      editHardware,
      editAttachment,
      editResource,
      editOtherCost,
    } = this.state
    const isEdit = editProjectInfo
    || editBreakDown
    || editVendor
    || editResource
    || editOtherCost
    || editLicense
    || editHardware
    || editAttachment
    || isEditRevenuePlanning
    || this.costPlanning.getIsEdit()
    || this.changeRequest.getIsEdit()
    || this.billing.getIsEdit()
    if (!isEdit || this.state.activeTab === tab) this.setState({ activeTab: tab })
    else this.props.showConfirm({ type: 'confirmDiscard', tab }, 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }

  handleDiscard = (tab) => {
    this.setState({
      activeTab: tab,
      editVendor: false,
      editProjectInfo: false,
      editBreakDown: false,
      editLicense: false,
      editHardware: false,
      editAttachment: false,
      editResource: false,
      editOtherCost: false,
    })
    this.props.setIsEditRevenuePlanning(false)
    this.costPlanning.resetIsEdit()
    this.changeRequest.resetIsEdit()
    this.billing.resetIsEdit()
    const access_token = localStorage.getItem('access_token')
    this.props.getProjectInformationByID(this.state.projectID, access_token)
    this.props.hideConfirm('confirmDiscard')
  }

  selectVersion = (e) => {
    this.setState({ selectedVersion: e.target.value })
    const access_token = localStorage.getItem('access_token')
    const snapshotID = e.target.value
    if (snapshotID === '') {
      this.props.getProjectInformationByID(this.state.projectID, access_token)
    } else {
      this.props.getSnapshot(snapshotID, access_token)
    }
  }

  closeResponseModal = () => {
    this.props.openResponseModal({ responseModal: { isOpen: false, res: {} } })
  }

  // handleScroll = () => {
  //   const root = document.getElementById('root')
  //   const currentScrollPos = root.scrollTop
  //   if (prevOffsetTop > currentScrollPos) {
  //     document.getElementById('navbar').style.position = 'sticky'
  //     document.getElementById('navbar').style.top = 0
  //   } else {
  //     document.getElementById('navbar').style.position = 'relative'
  //   }
  //   prevOffsetTop = currentScrollPos
  // }

  render() {
    const {
      lobs,
      activeTab,
      redirect,
      rSelected,
      employees,
      projectID,
      projectByID,
      // projectSubmit,
      editResource,
      editOtherCost,
      editVendor,
    } = this.state
    const accessToken = localStorage.getItem('access_token')
    const {
      hideHeader,
      getProjectInformationByID,
      editProjectInformation,
      autoFillManDays,
      incompletedList,
      showConfirm,
      hideConfirm,
      confirmType,
      confirmStatus,
      confirmMessage,
    } = this.props

    if (redirect) {
      return (<Redirect to={ {
        pathname: `/project_information`,
        state: { header: 'Project Information' },
      } }
      />)
    }

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectProject.isAuthenticated')
    const redirectToLogin = get(this.props, 'redirectAuth.redirect')
    || get(this.props, 'redirectProject.redirect')
    if (redirectToLogin) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    const isFetching = get(this.props, 'getIsFetching')
    const projectState = this.props.projectState
    const responseModal = projectState.responseModal

    // const marginTop = !this.props.docked && window.innerWidth <= 1280 ? '30px' : '0'

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper id='root'>
        <SimpleModal
          isOpen={ responseModal.isOpen }
          toggle={ this.closeResponseModal }
          { ...responseModal.res }
        />
        <CustomModal
          hide={ () => this.props.hideModal('alert') }
          show={ get(this.props, 'modalType') === 'alert' }
          type={ get(this.props, 'modalStatus') }
          message={ get(this.props, 'modalMessage') }
          fontColor='black'
        />
        <Manual
          isOpen={ get(this.props, 'isOpenManual') }
          typeManual={ get(this.props, 'typeManual') }
          closeManual={ get(this.props, 'closeManual') }
          setTypeManual={ get(this.props, 'setTypeManual') }
        />
        <HeaderWrapper id='navbar' hide_header={ hideHeader }>
          <Header
            { ...this.state }
            selectVersion={ this.selectVersion }
          />
          <Tab
            projectByID={ this.state.projectByID }
            activeTab={ this.state.activeTab }
            rSelected={ this.state.rSelected }
            incompletedList={ incompletedList }
            toggle={ this.toggle }
            onRadioBtnClick={ this.onRadioBtnClick }
          />
        </HeaderWrapper>
        <RowWrapper>
          <CustomModalMessage
            hide={ () => this.props.hideConfirm(get(this.props, 'confirmType')) }
            show={
              get(this.props, 'confirmType') === 'editSuccess' ||
              get(this.props, 'confirmType') === 'approveSuccess' ||
              get(this.props, 'confirmType') === 'errorEditResource' ||
              get(this.props, 'confirmType') === 'uploadFail' ||
              get(this.props, 'confirmType') === 'saveSnapshot'
            }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ (() => {
              if (get(this.props, 'confirmStatus') === 200) return buttonOK(get(this.props, 'confirmType'), this.props.hideConfirm, this.props)
              else if (get(this.props, 'confirmStatus') === 'Error') return buttonTryAgain(get(this.props, 'confirmType'), this.props.hideConfirm)
              return null
            })() }
          />
          <CustomModalMessage
            hide={ () => this.props.hideConfirm('confirmDiscard') }
            show={ get(this.props, 'confirmType.type') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard(get(this.props, 'confirmType.tab'), () => this.props.hideConfirm('confirmDiscard'), (tab) => this.handleDiscard(tab)) }
          />
          <TabContent activeTab={ activeTab } >
            { isFetching &&
              <Overlay>
                <OverlayWrapper>
                  <BeatLoader
                    css={ css(`
                          position: absolute;
                          left: 50%;
                          top: 50%;
                        `) }
                    sizeUnit={ "px" }
                    size={ 15 }
                    color={ '#D44B49' }
                    loading={ isFetching }
                  />
                </OverlayWrapper>
              </Overlay>
            }
            { this.state.activeTab === '1' &&
            <TabPane tabId="1">
              <OverviewTab
                selectedVersion={ this.state.selectedVersion }
                editProjectInfo={ this.state.editProjectInfo }
                editBreakDown={ this.state.editBreakDown }
                projectID={ this.state.projectID }
                projectByID={ this.state.projectByID }
                // projectSubmit={ this.state.projectSubmit }
                rSelected={ this.state.rSelected }
                users={ this.state.users }
                project_managers={ this.state.project_managers }
                clients={ this.state.clients }
                companys={ this.state.companys }
                lobs={ this.state.lobs }
                departments={ this.state.departments }
                last_submit_request={ this.state.last_submit_request }
                changeableProjectStatus={ this.state.changeableProjectStatus }
                approveProjectInformation={ this.props.approveProjectInformation }
                id={ get(this.props, 'authData.user._id') }
                canApprove={ get(this.props, 'location.state.canApprove') }
                clickEditProjectInfo={ () =>
                  this.setState({ editProjectInfo: !this.state.editProjectInfo }) }
                clickEditBreakDown={ () =>
                  this.setState({ editBreakDown: !this.state.editBreakDown }) }
              />
            </TabPane>
            }
            <TabPane tabId='2'>
              <CostPlanningTab
                ref={ e => { this.costPlanning = e } }
                hideHeader={ hideHeader }
                confirmType={ confirmType }
                confirmStatus={ confirmStatus }
                confirmMessage={ confirmMessage }
                editResource={ editResource }
                editOtherCost={ editOtherCost }
                editVendor={ editVendor }
                projectByID={ projectByID }
                rSelected={ rSelected }
                employees={ employees }
                getProjectInformationByID={ () => getProjectInformationByID(projectID, accessToken) }
                editProjectInformation={ (payload, commit) => editProjectInformation(projectID, payload, accessToken, commit) }
                showConfirm={ (type, status, message) => showConfirm(type, status, message) }
                hideConfirm={ (type) => hideConfirm(type) }
                autoFillManDays={ (payload) => autoFillManDays(projectID, payload, accessToken) }
              />
            </TabPane>
            <TabPane tabId='3'>
              <RevenuePlanningTab
                hideHeader={ hideHeader }
                activeTab={ activeTab }
                projectByID={ projectByID }
                rSelected={ rSelected }
                lobData={ lobs }
                toggle={ this.toggle }
                getProjectInformationByID={ () => getProjectInformationByID(projectID, accessToken) }
                editProjectInformation={ (payload, commit) => editProjectInformation(projectID, payload, accessToken, commit, true) }
              />
            </TabPane>
            <TabPane tabId='4'>
              <BillingTab
                ref={ e => { this.billing = e } }
                projectByID={ projectByID }
                rSelected={ rSelected }
                getProjectInformationByID={ () => getProjectInformationByID(projectID, accessToken) }
                editProjectInformation={ (payload, commit) => editProjectInformation(projectID, payload, accessToken, commit) }
              />
            </TabPane>
            <TabPane tabId="7">
              <ChangeRequestTab
                ref={ e => { this.changeRequest = e } }
                projectByID={ projectByID }
                rSelected={ rSelected }
                getProjectInformationByID={ () => getProjectInformationByID(projectID, accessToken) }
                editProjectInformation={ (payload, commit) => editProjectInformation(projectID, payload, accessToken, commit) }
              />
            </TabPane>
            { this.state.activeTab === '8' &&
            <TabPane tabId="8">
              <AttachmentTab
                hideHeader={ hideHeader }
                editAttachment={ this.state.editAttachment }
                id={ get(this.props, 'authData.user._id') }
                employees={ this.state.employees }
                projectByID={ this.state.projectByID }
                rSelected={ this.state.rSelected }
                uploadFile={ this.uploadFile }
                getProjectInformationByID={ () =>
                  this.props.getProjectInformationByID(this.state.projectID, localStorage.getItem('access_token'))
                }
                editProjectInformation={ (payload, commit) =>
                  this.props.editProjectInformation(this.state.projectID, payload, localStorage.getItem('access_token'), commit)
                }
                showConfirm={ (type, status, message) =>
                  this.props.showConfirm(type, status, message) }
                clickEditAttachment={ () =>
                  this.setState({ editAttachment: !this.state.editAttachment }) }
              />
            </TabPane>
            }
          </TabContent>
        </RowWrapper>
      </Wrapper>
    )
  }
}

ProjectInformationPage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  autoFillManDays: PropTypes.func.isRequired,
  editProjectInformation: PropTypes.func.isRequired,
  getProjectInformationByID: PropTypes.func.isRequired,
  approveProjectInformation: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getDepartment: PropTypes.func.isRequired,
  getClient: PropTypes.func.isRequired,
  getSnapshot: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectProject: projectInformationSelector.redirectProject,
  getProjectInformationData: projectInformationSelector.getProjectInformationData,
  getProjectInformationByIDData: projectInformationSelector.getProjectInformationByIDData,
  createProjectInformationData: projectInformationSelector.createProjectInformationData,
  editProjectInformationData: projectInformationSelector.editProjectInformationData,
  getIsFetching: projectInformationSelector.getIsFetching,
  autoFillManDaysData: projectInformationSelector.autoFillManDaysData,
  changeStatusProjectInformationData: projectInformationSelector.changeStatusProjectInformationData,
  submitProjectInformationData: projectInformationSelector.submitProjectInformationData,
  approveProjectInformationData: projectInformationSelector.approveProjectInformationData,
  saveSnapshotData: projectInformationSelector.saveSnapshotData,
  getSnapshotData: projectInformationSelector.getSnapshotData,
  isOpenManual: projectInformationSelector.isOpenManual,
  typeManual: projectInformationSelector.getTypeManual,
  getLOBData: lobSelector.getListLOB,
  getCompanyData: companySelector.getListCompany,
  getDepartmentData: departmentSelector.getListDepartment,
  getEmployeeData: employeeSelector.getListUser,
  getClientData: clientMasterSelector.getClientData,
  createClientData: clientMasterSelector.createClientData,
  docked: sidebarSelector.getDocked,
  isEditRevenuePlanning: projectInformationSelector.getIsEditRevenuePlanning,
  incompletedList: projectInformationSelector.getIncompletedRevenue,
  hideHeader: headerSelector.getIsHide,
  projectState: projectInformationSelector.getProjectInformation,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getProjectInformation: projectInformationAction.getProjectInformation,
  resetGetProjectInformation: projectInformationAction.resetGetProjectInformation,
  getProjectInformationByID: projectInformationAction.getProjectInformationByID,
  resetGetProjectInformationByID: projectInformationAction.resetGetProjectInformationByID,
  createProjectInformation: projectInformationAction.createProjectInformation,
  resetCreateProjectInformation: projectInformationAction.resetCreateProjectInformation,
  editProjectInformation: projectInformationAction.editProjectInformation,
  resetEditProjectInformation: projectInformationAction.resetEditProjectInformation,
  getLOB: lobAction.getLOB,
  getCompany: companyAction.getCompany,
  getDepartment: departmentAction.getDepartment,
  getEmployee: employeeAction.getUser,
  resetGetEmployee: employeeAction.resetListUser,
  getClient: clientMasterAction.getClient,
  createClient: clientMasterAction.createClient,
  resetCreateClient: clientMasterAction.resetCreateClient,
  autoFillManDays: projectInformationAction.autoFillManDays,
  resetAutoFillManDays: projectInformationAction.resetAutoFillManDays,
  resetChangeStatusProjectInformation: projectInformationAction.resetChangeStatusProjectInformation,
  resetSubmitProjectInformation: projectInformationAction.resetSubmitProjectInformation,
  approveProjectInformation: projectInformationAction.approveProjectInformation,
  resetApproveProjectInformation: projectInformationAction.resetApproveProjectInformation,
  resetSaveSnapshot: projectInformationAction.resetSaveSnapshot,
  resetGetSnapshot: projectInformationAction.resetGetSnapshot,
  closeManual: projectInformationAction.closeManual,
  setTypeManual: projectInformationAction.setTypeManual,
  getSnapshot: projectInformationAction.getSnapshot,
  setIsEditRevenuePlanning: projectInformationAction.editRevenuePlanningTable,
  openResponseModal: projectInformationAction.openResponseModal,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ProjectInformationPage))

const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 70px);
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #EEE;
`

const RowWrapper = styled.div`
  height: 100%;
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`

const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const HeaderWrapper = styled.div`
  display: ${p => (p.hide_header ? 'none' : 'flex')};
  flex-direction: column;
  transition: all 0.3s;
  z-index: 1;
  position: sticky;
  top: 0;
`



// WEBPACK FOOTER //
// ./src/pages/project-information/index.js